import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCredenciaisLoginAcesso]'
})
export class TiposCredenciaisLoginAcessoDirective {


  constructor(
    public ngControl: NgControl
  ) { }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event);
  }


  onInputChange(event) {


    let newVal = event.replace(/\s/g, '');


    if (newVal.length === 0) {
      newVal = '';
    }  else if (newVal.length === 11) {
      if (!this._testeNumerico(newVal) && !this._testeEmail(newVal)) {
          newVal = this._formatarCPF(newVal);
      }
    }

    this.ngControl.valueAccessor.writeValue(newVal);
  }




  private _testeNumerico(valor): Boolean {
    return isNaN(valor);
  }


  private _formatarCPF(valor): string {
    return valor.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '$1.$2.$3-$4');
  }


  private _testeEmail(email): Boolean {
    return /^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/.test(email);
  }




}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/directives/tipos-credenciais-login-acesso.directive.ts